/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RestoreJobInitiationResponse {
  /**
  * Restore job ID.
  */
  'jobId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "jobId",
      "baseName": "jobId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return RestoreJobInitiationResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

